"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.childrenSerializer = void 0;
var react_1 = require("react");
var engine_types_1 = require("@verified/c11-engine.types");
var circular_1 = require("./circular");
exports.childrenSerializer = {
    type: engine_types_1.GraphNodeType.EXTERNAL,
    name: "children",
    serializer: function (value) {
        if (value instanceof Array &&
            value.includes(function (x) { return !(0, react_1.isValidElement)(x); })) {
            return;
        }
        else if (!(0, react_1.isValidElement)(value)) {
            return;
        }
        var result = JSON.stringify(value, (0, circular_1.circular)());
        return result;
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hpbGRyZW5TZXJpYWxpemVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NoaWxkcmVuU2VyaWFsaXplci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFBdUM7QUFDdkMsa0RBQW1FO0FBQ25FLHVDQUFzQztBQUV6QixRQUFBLGtCQUFrQixHQUFvQjtJQUNqRCxJQUFJLEVBQUUsNEJBQWEsQ0FBQyxRQUFRO0lBQzVCLElBQUksRUFBRSxVQUFVO0lBQ2hCLFVBQVUsRUFBRSxVQUFDLEtBQUs7UUFDaEIsSUFDRSxLQUFLLFlBQVksS0FBSztZQUN0QixLQUFLLENBQUMsUUFBUSxDQUFDLFVBQUMsQ0FBTSxJQUFLLE9BQUEsQ0FBQyxJQUFBLHNCQUFjLEVBQUMsQ0FBQyxDQUFDLEVBQWxCLENBQWtCLENBQUMsRUFDOUM7WUFDQSxPQUFPO1NBQ1I7YUFBTSxJQUFJLENBQUMsSUFBQSxzQkFBYyxFQUFDLEtBQUssQ0FBQyxFQUFFO1lBQ2pDLE9BQU87U0FDUjtRQUNELElBQU0sTUFBTSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxFQUFFLElBQUEsbUJBQVEsR0FBRSxDQUFDLENBQUM7UUFDakQsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQztDQUNGLENBQUMifQ==